
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";
import { SimpleTag } from "../types/categoryRules";

interface TagBadgeProps {
  tag: SimpleTag;
  onRemove: () => void;
}

export const TagBadge = ({ tag, onRemove }: TagBadgeProps) => {
  return (
    <Badge
      variant="secondary"
      className="text-xs h-6 px-2 flex items-center gap-1"
      style={{ backgroundColor: tag.color + '20', color: tag.color }}
    >
      <div 
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: tag.color }}
      />
      {tag.name}
      <X
        className="w-2.5 h-2.5 cursor-pointer hover:text-red-500"
        onClick={onRemove}
      />
    </Badge>
  );
};
